export default __webpack_public_path__ + "static/media/Poseidon_Desktop.8f2a41dd.mp4";